// test2470
(2470 && 0);
